import { ActiveOrgContext } from '@/contexts/active-org-context'
import type { IActiveOrg } from '@/interface/base.interface'
import * as React from 'react'

interface ActiveOrgProviderProps {
  children: React.ReactNode
}

export const ActiveOrgProvider: React.FC<ActiveOrgProviderProps> = ({ children }) => {
  const [activeOrg, setActiveOrg] = React.useState<IActiveOrg>({
    id: '',
    name: '',
    logo: '',
    role: '',
    featurePermissions: [],
  })

  const value = React.useMemo(
    () => ({
      activeOrg,
      setActiveOrg,
    }),
    [activeOrg]
  )

  return <ActiveOrgContext.Provider value={value}>{children}</ActiveOrgContext.Provider>
}
